const BASE_URL = process.env.REACT_APP_API_URL ?? window.location.origin;

export interface ChatwootIdentity {
  identifier: string;
  identifier_hash: string;
}

// Fetches the HMAC identifier hash for the current user from the backend.
// Required for Chatwoot verified identity (setUser). Fails silently and
// returns null — the chat still works in unverified mode if this is missing.
// (window.fetch is wrapped by apiAuthInterceptor, which adds credentials.)
export const fetchChatwootIdentity = async (): Promise<ChatwootIdentity | null> => {
  try {
    const res = await fetch(`${BASE_URL}/api/v1/integrations/chatwoot/identity`);
    if (!res.ok) return null;
    return (await res.json()) as ChatwootIdentity;
  } catch {
    return null;
  }
};
